<template>
    <WrapBg title="" bgImg="myBg">
        <div>密码设置结果</div>
        <div class="cdPasswordResult">
            <i class="el-icon-success text-success"></i>
            <div>{{result}}</div>
        </div>
    </WrapBg>
</template>

<script>
    export default {
        name: "CdPasswordResult",
        data(){
            return{
                result:'',
            }
        },
        created() {
            this.result = this.$route.query.result;
        }
    }
</script>

<style lang="less" scoped>
    .cdPasswordResult{
        text-align: center;
        padding:40px;
        font-size:20px;
        i{
            font-size:40px;margin-bottom:20px;
        }
    }
</style>